import * as Utils from '../common/Utils.js';
//import axios from 'axios';
import { useQuery } from "@tanstack/react-query"

// fetch-retry can also wrap Node.js's native fetch API implementation:
const fetch = require('fetch-retry')(global.fetch);

const fetchDefaultOptions = {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'default', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'include', // include, *same-origin, omit
    headers: {
        'Content-Type': 'application/json',
        'embed-site': process.env.REACT_APP_EMBED_SITE
        // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //body: JSON.stringify("") // body data type must match "Content-Type" header
}

// #region Fetch API functions

export async function sendGetRequest(url = null)
{
    // type checking
    if (!Utils.isString(url))
    {
        //console.log("url is not a string: ", JSON.parse(JSON.stringify(url)));
        return null;
    }


    let responseData = '';
    url = process.env.REACT_APP_BASE_API_URL + url;

    //console.log("sendGetRequest url: ", JSON.parse(JSON.stringify(url)));

    await fetch(url, {
        credentials: 'include',
        headers: {
            'embed-site': process.env.REACT_APP_EMBED_SITE
        }
    })
        .then((response) =>
        {
            // not throwing errors here if error has occurred on server, the calling components will handle the response
            if(response.ok)
            {
                return response.json();
            }
            throw new Error('Something went wrong.');
        })
        .then((data) =>
        {
            //console.log("sendGetRequest " + JSON.parse(JSON.stringify(url)) + " response data: ", JSON.parse(JSON.stringify(data)));
            responseData = data;
        })
        .catch((error) =>
        {
            console.log("sendGetRequest " + JSON.parse(JSON.stringify(url)) + " error: ", JSON.parse(JSON.stringify(error)));
            responseData = error;
        });

    return responseData;
}

export async function sendPostRequest(url = null, data, isCustomURL = false)
{
    // type checking
    if (!Utils.isString(url))
    {
        //console.log("url is not a string");
        return null;
    }

    const dataJsonString = JSON.stringify(data);

    if (!Utils.isJsonString(dataJsonString))
    {
        //console.log("data is not json: ", JSON.parse(JSON.stringify(data)));
        return null;
    }

    let responseData = '';

    if (!isCustomURL)
        url = process.env.REACT_APP_BASE_API_URL + url;

    //console.log("sendPostRequest url: ", JSON.parse(JSON.stringify(url)));
    //console.log("sendPostRequest sending data: ", JSON.parse(JSON.stringify(data)));

    await fetch(
        url,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'embed-site': process.env.REACT_APP_EMBED_SITE
            },
            body: dataJsonString
        }
    )
        .then((response) =>
        {
            // not throwing errors here if error has occurred on server, the calling components will handle the response
            return response.json();
        })
        .then((data) =>
        {
            //console.log("sendPostRequest " + JSON.parse(JSON.stringify(url)) + " response data: ", JSON.parse(JSON.stringify(data)));
            responseData = data;
        })
        .catch((error) =>
        {
            console.log("sendPostRequest " + JSON.parse(JSON.stringify(url)) + " error: ", JSON.parse(JSON.stringify(error)));
            responseData = error;
        });

    return responseData;
}

export async function sendCustomRequest(url = null, options = fetchDefaultOptions)
{
    // type checking
    if (!Utils.isString(url))
    {
        //console.log("url is not a string");
        return null;
    }

    options = options ?? fetchDefaultOptions; // use default if undefined or null

    const optionsJsonString = JSON.stringify(options);

    if (!Utils.isJsonString(optionsJsonString))
    {
        //console.log("options is not json: ", JSON.parse(JSON.stringify(options)));
        return null;
    }

    let responseData = '';

    //console.log("sendCustomRequest url: ", JSON.parse(JSON.stringify(url)));
    //console.log("sendCustomRequest options ", JSON.parse(JSON.stringify(options)));

    //bodgy catch for add to basket
    if (options.body === 0)
    {
        //console.log("sendCustomRequest options.headers.body is 0");
        return null;
    }

    //const fetchPromise = await fetch(url, optionsJsonString);

    //fetchPromise
    //    .then((response) => {
    //        if (!response.ok) {
    //            console.log(`HTTP error: ${response.status}`);
    //            throw new Error(`HTTP error: ${response.status}`);
    //        }

    //        // extract json body content
    //        console.log(response.json());
    //        responseData = response.json();
    //    })
    //    .then((data) => {
    //        console.log(data);
    //        responseData = data;
    //    })
    //    .catch((error) => {
    //        console.error('Error:', error);
    //        responseData = error;
    //    });

    //return responseData;

    await fetch(
        url,
        options
    )
        .then((response) =>
        {
            // not throwing errors here if error has occurred on server, the calling components will handle the response
            return response.json();
        })
        .then((data) =>
        {
            //console.log("sendCustomRequest " + JSON.parse(JSON.stringify(url)) + " response data: ", JSON.parse(JSON.stringify(data)));
            responseData = data;
        })
        .catch((error) =>
        {
            console.log("sendCustomRequest " + JSON.parse(JSON.stringify(url)) + " error: ", JSON.parse(JSON.stringify(error)));
            responseData = error;
        });

    return responseData;
}

// #endregion Fetch API functions

// refetch abstraction
// jsonObject should be post data for POST request (type 2) or Request options json for type 3
export function useRefetchQuery(key, url, requestType = 1, jsonObject = null)
{
    // const { data, refetch } = useQuery(
    const { refetch } = useQuery(
        [key],
        async () =>
        {
            // GET
            if (requestType === 1)
            {
                return await sendGetRequest(url);
            }
            // POST
            else if (requestType === 2)
            {
                return await sendPostRequest(url, jsonObject);
            }
            // CUSTOM
            else if (requestType === 3)
            {
                return await sendCustomRequest(url, jsonObject);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: false // disable this query from automatically running
        }
    );

    return refetch;
}